import { __rest } from "tslib";
import * as React from 'react';
import { Button, ButtonVariant } from '../Button';
export var AlertActionLink = function AlertActionLink(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      children = _a.children,
      props = __rest(_a, ["className", "children"]);

  return React.createElement(Button, Object.assign({
    variant: ButtonVariant.link,
    isInline: true,
    className: className
  }, props), children);
};